import firebase from "firebase/compat/app";
import config from "../../config";
import "firebase/compat/auth";
import styled from "styled-components";
export const FireBase = () => {
    // Initialize Firebase
    firebase.initializeApp(config.firebaseConfig);
    // firebase.analytics();

    window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
      "recaptcha-container",
      {
        size: "invisible",
        callback: function (response) {
          // reCAPTCHA solved, allow signInWithPhoneNumber.
          console.log("recaptcha response", response);
          // firebase.auth.onSignInSubmit();
        },
      }
    );
  };


  export const ErrorLabel = styled.label`
    position: absolute;
    font-size: 12px;
    bottom: -15px;
    left: 0px;
    line-height: 14px;
    transition: 0.3s linear;
    background: #ffffff00;
    color: rgb(255, 0, 0);
  `;